import { Validators } from '../../../utils/validators';
import { FormModel } from '../../../components/Form';

export const ResetForm = (strings: any, firstTimeLogin: boolean): FormModel[] => {
  const passwordValidators = [{ check: Validators.validateMandatoryField }, { check: Validators.validatePassword }];

  return [
    {
      autoFocus: true,
      label: firstTimeLogin ? `${strings.old_password_text}` : `${strings.new_password_text}`,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'password',
      variant: 'outlined',
      placeholder: '',
      field: firstTimeLogin ? 'oldPassword' : 'password',
      validators: firstTimeLogin ? [{ check: Validators.validateMandatoryField }] : passwordValidators,
      sx: { mb: 2 },
      responsive: { xs: 12 },
      required: true,
    },
    {
      label: firstTimeLogin ? `${strings.new_password_text}` : `${strings.confirm_password_text}`,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'password',
      variant: 'outlined',
      placeholder: '',
      field: firstTimeLogin ? 'newPassword' : 'confirmPassword',
      validators: passwordValidators,
      responsive: { xs: 12 },
      required: true,
    },
  ];
};
